export const handleError = (error) => {
    return error?.response?.data?.message || error.message || "";
}